import React from 'react';
import {connect} from 'react-redux';
import strings from '../../utils/strings';

import AudioPlayer from '../../components/AudioPlayer';

import './styles.scss';
import {VARIATION} from '../../constants';

class Intro extends React.Component {
	constructor(props) {
		super(props);
		const variation = VARIATION;
		const language = strings.getLanguage();
		const audio = require(
			`../../assets/sounds/${variation}/${language}/2 1 ordkjedetekst.mp3`
		);
		this.audio = audio;
	}

	render() {
		const {onNextStep} = this.props;

		return (
			<div className="lit-intro">
				<div className="lit-intro__content">
					<div className="lit-intro__lead">
						<div className="lit-intro__audio">
							<AudioPlayer autoplay inline src={this.audio} />
						</div>

						<p className="lit-intro__paragraph lit-intro__paragraph--lead">
							{strings.ordkjedetestIntro}
						</p>
						<p className="lit-intro__paragraph">
							{strings.ordkjedetestIntro_1}
						</p>

						<p className="lit-intro__paragraph">
							{strings.letsStartwith2Trials}
						</p>

						<p className="lit-intro__paragraph">
							{strings.testStartGeneral}
						</p>
					</div>

					<button
						className="lit-btn lit-intro__button bg-primary"
						onClick={onNextStep}
					>
						{strings.showExamples}
					</button>
				</div>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
